// returns values
export default function values() {
  var length = this.length;
  var result = new Array(length);
  for (var i = 0; i < length; i++) {
    result[i] = this[i];
  }
  return result;
}